export default __webpack_public_path__ + "608ef9fad7fc3ce14960c1e7c682bda3.svg";